import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IAttachment, ITcmModel } from "@tylertech/tyler-api-types";
import { DocumentService } from "../documentService.g";

export interface AttachmentsDialogData
{
    readonly attachments: Array<IAttachment>;
    readonly docType: string;
    readonly entityId: string;
    readonly entityType: string;
    readonly isAdd: boolean;
    readonly readOnly: boolean;
    readonly tcmEntity: ITcmModel;
}

@Component({
    selector: "attachments-dialog",
    templateUrl: "./attachmentDialog.tmpl.html",
    standalone: false
})
export class AttachmentDialogComponent
    implements OnInit
{
    private readonly dialogRef = inject<MatDialogRef<AttachmentDialogComponent>>(MatDialogRef);
    private readonly data = inject<AttachmentsDialogData>(MAT_DIALOG_DATA);
    private readonly $documentApiService = inject(DocumentService);

    hasTcm: boolean;

    isLoaded: boolean = false;
    protected promise: Promise<void>;

    get entityId(): string { return this.data.entityId; }
    get entityType(): string { return this.data.entityType; }
    get isAdd(): boolean { return this.data.isAdd; }
    get tcmEntity(): ITcmModel { return this.data.tcmEntity; }
    get attachments(): Array<IAttachment> { return this.data.attachments; }
    get readOnly(): boolean { return this.data.readOnly; }
    get docType(): string { return this.data.docType; }

    ngOnInit(): void
    {
        this.promise = this.$documentApiService.HasTcm()
            .then(executionResult =>
            {
                this.hasTcm = executionResult.Result;
            })
            .finally(() =>
            {
                this.isLoaded = true;
                this.promise = undefined;
            });
    }

    close(): void
    {
        this.dialogRef.close();
    }
}
